import { Component, DestroyRef, OnInit, signal } from '@angular/core';
import { assets } from '../../core/constants/assets.const';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { enquiry, TransportPayment } from '../../models/enquiries';
import { Router, RouterModule } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';
import { CountryService } from '../../services/countryCurrency.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RideCompletedModalComponent } from '../ride-completed-modal/ride-completed-modal.component';
import { EnquiryService } from '../../services/enquiries.service';
import { SocketsService } from '../../services/sockets.service';
import { TranslatePipe } from '../../core/pipes/translate.pipe';

@Component({
  selector: 'logibids-ride-completed',
  imports: [CommonModule, ButtonModule, RouterModule, TranslatePipe],
  templateUrl: './ride-completed.component.html',
  styleUrl: './ride-completed.component.scss',
})
export class RideCompletedComponent implements OnInit {
  assetsConst = assets;
  protected enquiry = signal<enquiry | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user: any;
  currencyRate: string;
  ref: import('primeng/dynamicdialog').DynamicDialogRef;
  transactionEnequiry = signal<TransportPayment | null>(null);
  buttonDisabled = signal<boolean>(true);
  backToHome = signal<boolean>(false);

  constructor(
    public config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    private destroyRef: DestroyRef,
    private router: Router,
    private _encryption: EncryptionService,
    private _CountryService: CountryService,
    public dialogService: DialogService,
    private _EnquiryService: EnquiryService,
    private _socket: SocketsService
  ) {
    this.user = this._encryption.decryptLocalStorage('profile');
  }

  ngOnInit(): void {
    if (this.config.data.id && this.user) {
      this.transactionPay(this.config.data.id);
    }
    this.cashRecivedSocket();
  }

  cashRecivedSocket(): void {
    this._socket
      .userPaidEnquiry()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: { enquiry_id: number; payment_method: string }) => {
        if (res.payment_method === 'CASH') {
          this.buttonDisabled.set(false);
        } else {
          this.dialogRef.close();
          setTimeout(() => {
            this.router.navigateByUrl('/sp-bids/sp-auctions');
          }, 100);
        }
      });
  }

  cashRecieved(): void {
    this._CountryService
      .tripcashRecived(this.enquiry().id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.dialogRef.close();
        setTimeout(() => {
          this.rideCompletedShowCashPaid();
        }, 300);
      });
  }

  rideCompletedShowCashPaid() {
    this.ref = this.dialogService.open(RideCompletedModalComponent, {
      header: '',
      width: '26vw',
      height: '17vw',
      modal: true,
      closable: false,
      styleClass: 'ride_complet_modal',
      contentStyle: { overflow: 'auto' },
      data: this.enquiry(),
    });
  }

  btn_route(): void {
    // extra charge on a booking paid online: the user pays it in the app, nothing to confirm.
    // saved on the server so the popup does not open again on refresh
    if (this.transactionEnequiry().is_online_extra_charge) {
      const goHome = () => {
        this.router.navigateByUrl(this.user.type !== 'DRIVER' ? `/sp-bids/sp-auctions` : `/driver-home`);
        this.dialogRef.close();
      };
      this._EnquiryService
        .acknowledgeExtraCharge(this.transactionEnequiry().enquiry_id)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({ next: goHome, error: goHome });
      return;
    }

    this._EnquiryService
      .cashRecevied(this.transactionEnequiry().enquiry_id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          if (this.user.type !== 'DRIVER') {
            this.router.navigateByUrl(`/sp-bids/sp-auctions`);
          } else {
            this.router.navigateByUrl(`/driver-home`);
          }
          this.dialogRef.close();
        },
        // already settled meanwhile (e.g. paid online): reload to show Back to Home
        error: () => this.transactionPay(this.config.data.id),
      });
  }

  btn_home(): void {
    this.dialogRef.close();
    this.router.navigateByUrl(`/sp-bids/sp-auctions`);
  }

  // Transaction

  transactionPay(id): void {
    this._EnquiryService
      .getTransactionEnquiry(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: TransportPayment) => {
        // nothing left for the driver (e.g. already acknowledged, opened from a cached profile)
        if (res && res.is_payment_pending === false && !res.id) {
          this.dialogRef.close();
          return;
        }

        this.transactionEnequiry.set(res);
        if (
          this.transactionEnequiry().is_payment_pending === false &&
          this.transactionEnequiry().is_sp_paid == true
        ) {
          this.backToHome.set(true);
        }
        // cash booking (cash on delivery or paid by cash): the driver confirms the cash
        // without waiting for the user; extra charge on an online booking: the driver can leave
        this.buttonDisabled.set(
          !this.transactionEnequiry().user_paid_sp &&
            !this.transactionEnequiry().allow_cash_received &&
            !this.transactionEnequiry().is_online_extra_charge
        );
      });
  }
}
